import React from 'react';
import { motion } from 'framer-motion';
import AnimatedCounter from './AnimatedCounter';

const stats = [
  {
    value: 99,
    // color: 'text-green-600',
    label: 'Candidate Satisfaction Score',
  },
  {
    value: 89,
    // color: 'text-blue-600',
    label: 'New Business Through Referrals',
  },
  {
    value: 100,
    // color: 'text-purple-600',
    label: 'Fill Rate for Retained Search',
  },
];

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.18,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } },
};

const StatsSection = () => (
  <section className="py-16 ">
    <div className="max-w-4xl mx-auto px-4">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-semibold text-black mb-4">
          Find World-Class Tech Talent, Fast and Without Compromise.
        </h2>
      </div>
      <motion.div
        className="grid grid-cols-1 md:grid-cols-3 gap-5"
        variants={containerVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.4 }}
      >
        {stats.map((stat, i) => (
          <motion.div
            key={i}
            className="p-6 rounded-lg text-center"
            variants={cardVariants}
          >
            <div className={`text-4xl font-bold ${stat.color} mb-2`}>
              <AnimatedCounter value={stat.value} />%
            </div>
            <p className="text-gray-600">{stat.label}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default StatsSection; 